const angularCodeHTML = `<button (click)="requestApi()">test</button>`;

export default angularCodeHTML;
